import { render, staticRenderFns } from "./OpenApplet.vue?vue&type=template&id=1b77299a&scoped=true"
import script from "./OpenApplet.vue?vue&type=script&lang=js"
export * from "./OpenApplet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77299a",
  null
  
)

export default component.exports